// /users DataGrid 컬럼 정의.
// flex 전면 제거 → width + minWidth 고정. 넘치는 컬럼은 그리드 내부 가로 스크롤로 처리된다.

import { EditButton } from "@refinedev/mui";
import type { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { OverflowTooltip } from "components/list";
import { IUser } from "../interfaces";

// 수정일 문자열 포맷 (기존 로직 유지)
const formatUpdatedDate = (value: unknown): string => {
  const date = new Date(value as string);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();

  const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
  const amPm = hours < 12 ? "오전" : "오후";
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

  return `${date.getFullYear()}년 ${date.getMonth() + 1}월 ${date.getDate()}일 ${amPm} ${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

export const usersColumns: GridColDef<IUser>[] = [
  { field: "id", headerName: "ID", type: "number", width: 84, minWidth: 72, align: "center", headerAlign: "center" },
  { field: "loginId", headerName: "로그인 ID", type: "string", width: 150, minWidth: 120 },
  {
    field: "nickName",
    headerName: "닉네임",
    width: 200,
    minWidth: 160,
  },
  {
    field: "phoneNumber",
    headerName: "전화번호",
    width: 140,
    minWidth: 120,
    renderCell: (params: GridRenderCellParams) => {
      const formattedPhoneNumber =
        params.value && params.value.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
      return <OverflowTooltip value={formattedPhoneNumber} />;
    },
  },
  {
    field: "updatedDate",
    headerName: "수정일",
    width: 225,
    minWidth: 180,
    renderCell: (params: GridRenderCellParams) => (
      <OverflowTooltip value={formatUpdatedDate(params.value)} />
    ),
  },
  {
    field: "actions",
    headerName: "Actions",
    width: 100,
    minWidth: 90,
    sortable: false,
    renderCell: (params: GridRenderCellParams) => (
      <div>
        <EditButton hideText recordItemId={params.row.id} />
      </div>
    ),
  },
];
